import type { TemplateName } from '../core/assetType.js';

/**
 * What a template lets an activity leave out.
 *
 * The activity modules judge one activity with no document around it, but a few of
 * their fields mean different things under different templates. A gameshow's host asks
 * each round's question in the node's narrator dialogue (the gameshow validator requires
 * it there), so a quiz activity's own `question` is null by design; on every other
 * template the question is what the player reads above the answers, and null is a hole.
 */
export const QUESTION_NULLABLE_TEMPLATES: readonly TemplateName[] = ['gameshow'];

/** Whether an activity's `question` may be null under this template. Unknown means no. */
export const questionMayBeNull = (templateName: TemplateName | undefined): boolean =>
  templateName !== undefined && QUESTION_NULLABLE_TEMPLATES.includes(templateName);
